let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j0PWv"), load("ksTQ6"), load("eBoC7"), load("j5F5K"), load("cukQS"), load("5FaEJ")]).then(() => parcelRequire('eEPOC'));